<template>
    <v-row>
        <v-col cols="12">
            <v-row class="mx-1">
                <v-col cols="12">
                    {{ $t("eventWaiver.text_step_1_1") }}
                </v-col>
                <v-col cols="12">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="openAddSpectator"
                    >{{ $t("eventWaiver.add_spectator_participant") }}</v-btn>
                </v-col>
                <v-col cols="12">
                    <v-data-table
                        :headers="peopleHeader"
                        :items="peopleItems"
                        :item-class="rowClass"
                        :options="{itemsPerPage:-1}"
                        class="elevation-1 peopleList"
                        item-key="userId"
                        dense 
                        :footer-props="{
                            'items-per-page-text': $t('dataTable.rowsPerPageText'),
                            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                        }"
                        :no-data-text="$t('dataTable.noDataText')"
                        :headerProps="{
                            'sort-by-text': $t('dataTable.sortByText')
                        }"
                    >
                    <template v-slot:[`header.selected`]="{}">
                        <v-checkbox
                              v-model="selectAll"
                              @change="selectAllChange"
                        ></v-checkbox>
                    </template>
                    <template v-slot:[`item.selected`]="{ item }">
                        <v-checkbox
                              v-model="item.selected"
                              :disabled="item.disabled"
                              @change="updateCheck"
                        ></v-checkbox>
                    </template>
                    <template v-slot:[`item.eligibility`]="{ item }">
                        <div v-if="!item.hasBirthday">
                            <v-icon @click="openBirthdayInfo(item)" style="cursor:pointer;">far fa-question-circle</v-icon>
                            <span style="color:red; cursor:pointer;" class="ml-2" @click="openBirthdayInfo(item)">
                                {{ $t("eventWaiver.birthday_missing") }}
                            </span>
                        </div>
                        <div v-else class="d-flex justify-center align-center">
                            <v-icon color="green">fas fa-check-circle</v-icon>
                        </div>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row class="ml-1 mr-1">
                <v-col md="6" class="text-left">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="$emit('backStep')"
                    >{{ $t("common.prev") }}</v-btn>
                </v-col>
                <v-col md="6" class="text-right">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="next"
                        :disabled="disabledLoadingStep1"
                        :loading="disabledLoadingStep1"
                    >{{ $t("common.next") }}</v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title class="headline">{{ $t('eventWaiver.add_spectator_participant') }}</v-card-title>
                <v-card-text>
                    <p class="mt16">{{ $t('eventWaiver.add_spectator_participant_confirm') }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-btn 
                        class="btn mb-2 mr-2" 
                        :color="`${buttonColor}`" 
                        @click="addSpectator"
                    >{{ $t('eventWaiver.add_spectator') }}</v-btn>
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn mb-2"
                        @click="addParticipant"
                    >{{ $t('eventWaiver.add_participant') }}</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="birthdayInfoDialog" max-width="450px">
            <v-card>
                <v-card-title class="text-h6">{{ $t("eventWaiver.birthday_missing") }}</v-card-title>
                <v-card-text>
                    <p>{{ $t("eventWaiver.birthday_missing_info") }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="birthdayInfoDialog = false">{{ $t("common.close") }}</v-btn>
                    <v-btn :color="`${buttonColor}`" class="btn" @click="goToProfile">{{ $t("eventWaiver.go_to_profile") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { 
    VRow, VCol, VBtn, VDataTable, VDialog, VCard, VCardTitle, VCardText,
    VCardActions, VSpacer, VCheckbox, VIcon
} from 'vuetify/lib';
import LocalStorageService from "@/services/LocalStorageService";
import RelationshipService from "@/services/RelationshipService";
import EventWaiverService from "@/services/EventWaiverService";
import { mapState } from "vuex";

export default {
    components: {
        VRow, VCol, VBtn, VDataTable, VDialog, VCard, VCardTitle, VCardText,
        VCardActions, VSpacer, VCheckbox, VIcon
    },
    props: {
        userSession: { type: [Object, Boolean], default: false },
        bandStep2: { type: Boolean, default: false },
        participantsPrevius: Array
    },
    data() {
        return {
            buttonColor: "#000",
            peopleItems: [],
            singleSelect: false,
            selectedPeople: [],
            dialog: false,
            birthdayInfoDialog: false,
            disabledLoadingStep1: false,
            selectAll: false
        }
    },
    computed: {
        peopleHeader() {
            let header = [
                { text: '', value: "selected", sortable: false },
                { text: this.$t("eventWaiver.livelaps_id"), value: "userId" },
                { text: this.$t("eventWaiver.firstName"), value: "fName" },
                { text: this.$t("eventWaiver.lastName"), value: "lName" },
                { text: this.$t("eventWaiver.email"), value: "email" },
                { text: this.$t("eventWaiver.eligibility"), value: "eligibility", align: "center", sortable: false }
            ];
            return header;
        },
        ...mapState({
            userStore: (state) => state.session.user
        }),
        eventId() {
            return this.$route.query.eventId;
        }
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
        if(this.userStore) this.getList();
    },
    methods: {
        async getList() {
            let roles = [];
            await RelationshipService.getUserRoles().then(response =>{
                if(response.data.success == 1){
                    roles = response.data.message.filter(x => {
                        return x.userRoleCode === 'Participant' || x.userRoleCode === 'Spectator';
                    }).map((x) => {
                        return x.id
                    });
                }
            });
            await EventWaiverService.getRelationshipList({
                rolesId: roles, 
                eventId: this.eventId, 
                withUserLogin: true,
                authorizedUser: true
            }).then(response => {
                if(response.data.success == 1){ 
                    response.data.message.forEach(element => {
                        let disabledWaiver = false; let bandWaiver = false;
                        let age = this.getAge(element.birthday);
                        let adultAge = element.adultAge || 18;
                        let ageTarget = age >= adultAge ? 'Adult' : 'Minor';
                        if(element.eventWaiver && Array.isArray(element.eventWaiver)) {
                            element.eventWaiver.forEach((el1) => {
                                if(el1.data && el1.data.ageTarget == ageTarget && el1.data.waiverType) {
                                    bandWaiver = true;
                                }
                            });
                        } else if(!this.eventId) {
                            bandWaiver = true;
                        }
                        disabledWaiver = !bandWaiver;
                        const hasBirthday = !!element.birthday;
                        this.peopleItems.push({ 
                            ...element, 
                            eventWaiver: this.eventId ? element.eventWaiver : { value: true, data: undefined }, 
                            selected: false, 
                            eventWaiverArray: { value: false, data: undefined },
                            age, ageTarget,
                            hasBirthday,
                            disabled: !hasBirthday || disabledWaiver,
                            disabledWaiver
                        });
                    });
                    this.loadParticipantsCheck();
                }
            });
            //this.$store.dispatch('setLoadingPageAction',false);
        },
        loadParticipantsCheck() {
            this.peopleItems.forEach((el) => {
                this.participantsPrevius.forEach((el1) => {
                    if(el.userId == el1.userId && !el.disabled && el1.selected) {
                        el.selected = true;
                    }
                });
            });
            this.refreshSelectedPeople();
        },
        next() {
            this.disabledLoadingStep1 = true;
            let bam= false
            this.selectedPeople.forEach((element) => {
                if(element.email=="")
                    bam=true
            });
            if(bam){
                this.$emit('showSnackBar', { msg: this.$t("eventWaiver.invalid_step_1_email"), color: "error" });
                this.disabledLoadingStep1 = false;
                return;
            }
            if(this.selectedPeople.length == 0) {
                this.$emit('showSnackBar', { msg: this.$t("eventWaiver.invalid_step_1"), color: "error" });
                this.disabledLoadingStep1 = false;
                return;
            }

            if(!this.bandStep2) {
                this.$emit('loadEvent');
            } else {
                this.$emit('nextStep');
                this.disabledLoadingStep1 = false;
            }
        },
        openAddSpectator() {
            this.dialog = true;
        },
        openBirthdayInfo() {
            this.birthdayInfoDialog = true;
        },
        goToProfile() {
            this.birthdayInfoDialog = false;
            this.$router.push({ name: 'Profile' });
        },
        addSpectator() {
            LocalStorageService.setItem("create_waiver_desc", 'Spectator');
            this.$router.push({ name: 'SpectatorsCreate' });
        },
        addParticipant() {
            LocalStorageService.setItem("create_waiver_desc", 'Participant');
            this.$router.push({ name: 'RidersCreate' });
        },
        updateCheck() {
            const peoplesWaivers = this.peopleItems.filter((el) => !el.disabled);
            const peoplesSelected = this.peopleItems.filter((el) => el.selected);
            if(peoplesSelected.length >= peoplesWaivers.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
        }
            this.refreshSelectedPeople();
    },
        selectAllChange(newValue) {
            if(newValue) {
                this.peopleItems.forEach((el,i) => {
                    if(!el.disabled) {
                        this.peopleItems[i].selected = true;
                    } else {
                        this.peopleItems[i].selected = false; 
                    }
                });
            } else {
                this.peopleItems.forEach((el,i) => {
                    this.peopleItems[i].selected = false; 
                });
            }
            this.refreshSelectedPeople();
        },
        refreshSelectedPeople() {
            this.selectedPeople = this.peopleItems.filter(el => el.selected);
        },
        rowClass(item) {
            return item.disabled ? 'grayC' : '';
        },
        getAge(birthday){
            const birthdayDay = new Date(birthday);
            const nowDay = new Date();
            let age = nowDay.getFullYear() - birthdayDay.getFullYear();
            let differenceMonths = nowDay.getMonth() - birthdayDay.getMonth();
            if(differenceMonths < 0 || (differenceMonths == 0 && nowDay.getDate() < birthdayDay.getDate())) {
                age--;
        }
            return age;
        }
    },
    watch: {
        selectedPeople(val) {
            this.$emit("changePeoplesList", val);
        },
        userStore(val) {
            if(val) {
                const hasBirthday = !!val.birthday;
                this.peopleItems.push({
                    birthday: val.birthday,
                    email: val.email,
                    fName: val.firstName,
                    lName: val.lastName,
                    linkedMemberId: null,
                    relationship: "You",
                    userId: val.id,
                    userRoleCode: "Participant,Spectator",
                    userRoleId: [],
                    selected: false,
                    hasBirthday,
                    disabled: !hasBirthday
                });
                this.getList();
            }
        } 
    }
}
</script>

<style scss>
    .v-data-table .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
        height: 23px;
    }
    .grayC {
        background: #ccc;
    }
</style>